import React from 'react';
import axios from 'axios';

 var name;
let count=0;
let th;
      
export default class Dummy extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          name:"---"
      }
      this.setLocalStorage=this.setLocalStorage.bind(this);
      th=this
    }


    componentWillMount(){
        console.log("diddmounttt")
        // let params="";
        // axios.get('192.168.225.78:8000/getLoginCount', {     
        //   }).then(res => {
        //       console.log(res,"resss")
        //   })
       this.setLocalStorage("venugop");
       this.setState({
        name:JSON.parse(localStorage.getItem("name"))
    })
        //   localStorage.setItem("name", JSON.stringify({name:"venugopaal"}));
    }

    componentDidMount(){
        // name = localStorage.getItem("name");
        // console.log(JSON.parse(name),"name")
        // if(name){
           
        //     this.setState({
        //         name:JSON.parse(name)
        //     })
        // }
        setInterval(function(){
            th.setLocalStorage("heyyyyyyy huuu"+count++);
            }, 5000);
    }

     setLocalStorage(param){
        localStorage.setItem("name", JSON.stringify({name:param}));
        this.setState({
            name:JSON.parse(localStorage.getItem("name"))
        })

      }


    render(){
        name = localStorage.getItem("name");
        console.log(JSON.parse(name),"name")
        if(name){
           
           
                name=JSON.parse(name)
            
        }
       

        return(
        <div>{this.state.name.name}</div>
        )

        }

}




